var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal modal--presentation modal-presentation"},[_c('form-presentation',{on:{"close":function($event){return _vm.$emit('close')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }